import { render, staticRenderFns } from "./habitMedicationForm.vue?vue&type=template&id=afd0a6dc&scoped=true"
import script from "./habitMedicationForm.vue?vue&type=script&lang=js"
export * from "./habitMedicationForm.vue?vue&type=script&lang=js"
import style0 from "./habitMedicationForm.vue?vue&type=style&index=0&id=afd0a6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd0a6dc",
  null
  
)

export default component.exports